import TopicOne from "../crypto-market-contents/TopicOne";

const CryptoMarketContentOne = () => {
  return (
    <>
      <TopicOne />

      <div className="how__work__market">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h3>24/7 Market Access</h3>
                <p>Trade anytime, anywhere — crypto markets are always open.</p>

                <h3>Instant Execution</h3>
                <p>
                  Execute orders in milliseconds, even during high volatility.
                </p>

                <h3>No Hidden Fees</h3>
                <p>
                  Transparent pricing ensures you always know your costs
                  upfront.
                </p>

                <h3>Wide Asset Range</h3>
                <p>
                  Trade Bitcoin, Ethereum, Litecoin, and more from a single
                  account.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/crypto_cfd/crypto_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CryptoMarketContentOne;
